import { useGetIdsHealthcareservicesHcsIdDetails } from '@toktokdoctech/tokapi-client'
import useCurrentHcs from '../../hooks/useCurrentHcs'
import { EstablishmentForm } from './EstablishmentForm'
import Loader from '../Common/Loader/Loader'

export const EstablishmentContainer = () => {
    const currentHcs = useCurrentHcs()
    const { data, isLoading } = useGetIdsHealthcareservicesHcsIdDetails(currentHcs.id)

    if (isLoading || !data) return <Loader />
    return <EstablishmentForm initialEstablishmentData={data} />
}
